import './Contact.scss';
import Component from './Contact.js';
export default Component;
